// jQuery の $.ajax に Rails の CSRF トークンを自動付与する。
//
// このアプリは @rails/ujs を使っているが、@rails/ujs は data-remote / data-method の
// リンク・フォームしか面倒を見ず、直接書かれた $.ajax にはトークンを付けない
// （旧 jquery-ujs は $.ajaxPrefilter を仕込んでいたが、後継では削除された）。
//
// そのためビュー内の $.ajax は全てトークン無しで飛んでおり、CSRF 検証に失敗していた。
// これを避けるために各コントローラが protect_from_forgery の except に個別の
// アクションを並べるという回避策が取られていたが、除外はその分だけ保護が外れる。
// ここで一括して付与するのが本来の形。
//
// 対象は同一オリジンかつ GET/HEAD 以外。クロスオリジンにトークンを漏らさないよう
// crossDomain を確認する。
import jQuery from "jquery";

jQuery.ajaxPrefilter((options, originalOptions, xhr) => {
  if (options.crossDomain) return;

  const method = (options.type || options.method || "GET").toUpperCase();
  if (method === "GET" || method === "HEAD") return;

  const token = document.querySelector("meta[name=csrf-token]");
  if (token) xhr.setRequestHeader("X-CSRF-Token", token.content);
});
